export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1","charset":"utf-8"},{"charset":"utf-8","name":"viewport","content":"width=device-width,initial-scale=1,maximum-scale=2"}],"link":[{"rel":"preconnect","href":"https://www.googletagmanager.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://connect.facebook.net","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://js.sentry-cdn.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://assets.stringking.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://assets.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://cms-static.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://sk-cms.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://images.stringking.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://images.stringking.com","crossorigin":"anonymous"},{"rel":"icon","type":"image/x-icon","href":"https://assets.stringking.com/static/sites/stringking/icons/favicon.ico"}],"style":[],"script":[{"key":"ga4-script","tagPriority":896,"async":true,"defer":true,"src":"https://www.googletagmanager.com/gtag/js?id=G-6BRCXY45RQ","crossorigin":"anonymous"},{"key":"ga4-setup","tagPriority":897,"type":"text/javascript","innerHTML":"console.info('LOADING GA4 ...'); window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','G-6BRCXY45RQ',{\"debug_mode\":false});"},{"key":"meta-pixel-setup","tagPriority":910,"type":"text/javascript","innerHTML":"!(function(f,b,e,v,n,t,s) {if (f.fbq) return; console.info('LOADING META PIXEL...'); n=f.fbq=function(){n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments);}; if (!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version=\"2.0\"; n.queue=[]; t=b.createElement(e); t.async=!0; t.src=v; t.addEventListener('load',function(){setTimeout(() => { console.info('META PIXEL LOADED!'); fbq('init','516454267444862'); fbq('track','PageView');}, 1000);},false); s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);})(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');","async":true,"defer":true},{"key":"sentry-init","tagPriority":998,"type":"text/javascript","innerHTML":"!function(n,o){o=n.sentryConfigObj={\"release\":\"d3ff555\",\"initialize\":true,\"debug\":false,\"environment\":\"production\",\"sendDefaultPii\":true,\"tunnel\":\"/api-local/sentry\",\"sampleRate\":0.2,\"ignoreSpans\":[{\"op\":{}},{\"op\":\"resource.other\",\"name\":{}},{\"op\":\"resource.link\",\"name\":{}},{\"op\":{},\"name\":{}},{\"op\":{},\"name\":{}},{\"op\":\"measure\"}],\"tracing\":{\"tracesSampleRate\":0.2,\"vueOptions\":{\"tracing\":true,\"tracingOptions\":{\"hooks\":[\"mount\",\"update\"],\"timeout\":2000,\"trackComponents\":true}}}},n.sentryOnLoad=function(){n.console.log(\"Sentry LOADED!\"),Sentry.init(o)}}(window);","tagPosition":"bodyClose","crossorigin":"anonymous"},{"key":"sentry-loader","tagPriority":999,"src":"https://js.sentry-cdn.com/e09b14886f4f4820a271b7693018003f.min.js","crossorigin":"anonymous","tagPosition":"bodyClose"}],"noscript":[],"htmlAttrs":{"lang":"en"}}

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false